import { PROTOCOL, type IChannel } from '@/entities/channel';

type ChannelPhoneSource = Pick<IChannel, 'protocol'> &
  Partial<Pick<IChannel, 'name' | 'phone_number'>>;

const PHONE_CHANGE_PROTOCOLS = new Set<string>([
  PROTOCOL.TELEGRAM_PERSONAL,
  PROTOCOL.WHATSAPP_GRAY,
]);

export const canChangeChannelPhone = (channel: ChannelPhoneSource) =>
  PHONE_CHANGE_PROTOCOLS.has(channel.protocol);

export const getChannelSettingsPhone = (channel: ChannelPhoneSource) => {
  const phoneNumber = channel.phone_number?.trim();
  if (phoneNumber) return phoneNumber;

  if (channel.protocol === PROTOCOL.MAX_PERSONAL) {
    return channel.name?.trim() ?? '';
  }

  return '';
};
